import { AxiosInstanceFunc, HZAxiosInstanceFunc, setAxiosConfig } from '@hz-insights/web-components'
import { ticketConfig } from 'utils/synchronizeTicket'
import { installChartLangInterceptor } from 'utils/chartLang'

setAxiosConfig({
  baseURL: process.env.REACT_APP_API_BASEURL,
  timeout: 500000
})

// 组件库 axios 实例在其模块加载时即创建并固化配置(见组件库 AxiosInstance.js: axios.create(getAxiosConfig()))。
// 模块评估顺序若使实例先于上面的 setAxiosConfig 创建, baseURL 会永久丢失,
// 全部 API 请求打到站点根路径(生产 404)。这里显式回写 defaults, 与评估顺序彻底解耦。
AxiosInstanceFunc.defaults.baseURL = process.env.REACT_APP_API_BASEURL
HZAxiosInstanceFunc.defaults.baseURL = process.env.REACT_APP_API_BASEURL
AxiosInstanceFunc.defaults.timeout = 500000
HZAxiosInstanceFunc.defaults.timeout = 500000

installChartLangInterceptor()

ticketConfig.synchronizeCookie2LocalStorage()

// 本地开发免登录: 注入预置 token(仅 development, 生产无此行为); 须在 cookie 同步之后执行, 否则会被清除。
// 注意是覆盖写入: 浏览器里若残留旧 token(过期或属于其他账号)会导致所有图表"没有权限",
// 本地测试环境必须保证身份一致。
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_DEV_TOKEN) {
  const devToken = process.env.REACT_APP_DEV_TOKEN
  localStorage.setItem('token', devToken)
  // 组件库在模块加载时把 localStorage 的 token 静态固化进 Authorization 默认头(见组件库 AxiosInstance.ts),
  // 首次打开页面时 localStorage 还没有 token, 请求头为空导致 401(首屏白屏/未登录态), 刷新一次才恢复。
  // 这里显式同步两个 axios 实例的请求头, 保证首次加载即带 dev 身份。
  AxiosInstanceFunc.defaults.headers.common['Authorization'] = `bearer ${devToken}`
  HZAxiosInstanceFunc.defaults.headers.common['Authorization'] = `bearer ${devToken}`
}
